import { isPlatformServer } from '@angular/common';
import * as UAParser from 'ua-parser-js';
import * as i0 from "@angular/core";
import * as i1 from "@nguniversal/express-engine/tokens";
var UserAgent = /** @class */ (function () {
    function UserAgent(platformId, request) {
        this.platformId = platformId;
        this.request = request;
    }
    UserAgent.prototype.isMobileDevice = function () {
        return this.getUserAgent().getDevice().type !== undefined;
    };
    /**
     * Checks if the browser in use is IE or not
     *
     * @remark
     *
     * WARNING: Avoid using this since you should generally not be running IE
     * specific code.
     */
    UserAgent.prototype.isBrowserIE = function () {
        var ua = this.getUserAgent();
        var name = ua.getBrowser().name;
        return name === 'IE';
    };
    UserAgent.prototype.getUserAgent = function () {
        if (isPlatformServer(this.platformId)) {
            return new UAParser(this.request.get('User-Agent'));
        }
        return new UAParser(window.navigator.userAgent);
    };
    UserAgent.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserAgent_Factory() { return new UserAgent(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.REQUEST, 8)); }, token: UserAgent, providedIn: "root" });
    return UserAgent;
}());
export { UserAgent };
